import React from 'react';
import { Rating } from '@material-ui/lab';
import { Colors, Text } from 'library';

const ProviderReviews = ({ totalReviews, reviewScore }: { totalReviews?: number; reviewScore?: number }) => {
    return totalReviews ? (
        <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
            <Rating size="small" value={reviewScore} style={{ color: Colors.turquoise }} readOnly />
            <Text variant="body2" bold color={Colors.turquoise}>
                ({totalReviews})
            </Text>
        </div>
    ) : null;
};

export default ProviderReviews;
